export default function DSA_Quick_Sort_Time() {
  return <div>DSA_Quick_Sort_Time Component</div>;
}
